import APIClient from '@/shared/http/clients/api'

const APIPci = process.env.APIBaseURLPci
const resourceName = 'PDRDepartamentoConta'

const GetAll = (companyId, accountId, data = {}, config = {}) => APIClient.get(`${APIPci}/${resourceName}/empresa/${companyId}/conta/${accountId}`, data, config)
const Create = (companyId, accountId, data = {}, config = {}) => APIClient.post(`${APIPci}/${resourceName}/empresa/${companyId}/conta/${accountId}`, data, config)

const PDRDepartamentoContaRepository = {
  GetAll,
  Create
}

export default PDRDepartamentoContaRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/pci/pdrdepartamentoconta.js